import React from 'react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/content';
const subjects = ['Diagnosis', 'Biomechanics', 'Anchorage', 'Alignment', 'Space closure', 'Finishing'];
export function About() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-34" data-mp="12qdf1faob1q8">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[0.9fr_1.1fr] md:items-start" data-id="element-35" data-mp="ypl8itt6raxn">
        <img src={images.doctor} alt="Dr. Nathan Brooks in his orthodontic clinic" className="w-full rounded-3xl object-cover shadow-[0_30px_60px_-30px_rgba(38,16,64,0.5)] md:sticky md:top-8" data-id="element-36" data-mp="azhcb7ibudgo" />
        <div data-id="element-37" data-mp="jt2pwnir9ooi">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-600" data-id="element-38" data-mp="jtly3cilsypc">About the creator</p>
          <h2 className="mt-2 font-serif text-[34px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-39" data-mp="f01b0fijtp4x">Dr. Nathan Brooks</h2>
          <p className="mt-2 text-[15px] font-semibold text-muted" data-id="element-40" data-mp="3nerqvupr9jsv">
            Orthodontist · Clinical Educator · Creator of the Ortho Decision System™
          </p>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-41" data-mp="338p5bbwb8cyg">
            <p data-id="element-42" data-mp="3870hvudzp1kd">For years, I noticed the same pattern in orthodontic education. We learn each subject separately:</p>
            <p className="flex flex-wrap gap-2" data-id="element-43" data-mp="3czjrkg9k3cjw">
              {subjects.map(s => <span key={s} className="rounded-lg bg-brand-50 px-3 py-1 text-sm font-semibold text-brand-800" data-id="element-44" data-mp="3hwtjc2kf40aw">
                  {s}
                </span>)}
            </p>
            <p data-id="element-45" data-mp="2paikawcgm7g7">
              But eventually we sit in front of a real patient and all of those subjects arrive at the same time. And that’s
              when the difficult question appears:
            </p>
            <p className="border-l-4 border-brand-600 pl-4 font-serif text-2xl font-bold italic text-brand-800" data-id="element-46" data-mp="2z8epz8mmoa6x">
              “What should I decide first?”
            </p>
            <p data-id="element-47" data-mp="egmpenrt1hfb">
              I didn’t want to create another course filled with hours of lectures. I wanted a practical system that helps
              you organize the information you already have into a repeatable decision process.
            </p>
            <p className="rounded-2xl bg-brand-800 p-4 text-center text-[13px] sm:text-sm font-bold uppercase tracking-wide text-white" data-id="element-48" data-mp="25nk862v4w83p">
              Problem → Objective → Movement → Control → Risk → Checkpoint → Next decision
            </p>
            <p data-id="element-49" data-mp="1rtjdplb7t795">
              The system isn’t designed to replace your education, your experience, or your clinical judgment. It’s designed to
              give you a clearer framework for organizing your thinking.
            </p>
            <p className="font-serif text-xl italic text-brand-700" data-id="element-50" data-mp="20nxujsbe8pud">— Dr. Nathan Brooks</p>
          </div>

          <div className="mt-8" data-id="element-51" data-mp="1vud4qnjyf269">
            <CtaButton label="Start using the system" data-id="element-52" data-mp="186285wlajons" />
          </div>
        </div>
      </div>
    </section>;
}